import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import classNames from "classnames";

import { CCard, CCardBody } from "@coreui/react";

import { phieuChamDiemNCCApi } from "src/1/apis/phieu_cham_diem_nha_cung_cap.api";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { FormTable, FormToolbar } from "../../components";

const DanhSachNhaCungCapChamDiem = () => {
  //#region Data
  const params = useParams();

  const { data } = useQuery({
    queryKey: ["chi-tiet-phieu-cham-diem-ncc", params?.id],
    queryFn: () => phieuChamDiemNCCApi.getById(params?.id),
    enabled: !!params?.id,
    select: (response) => response?.data?.data,
  });

  const isMobile = useMobileDevice();
  //#endregion

  //#region Render
  return (
    <>
      <CCard className={classNames("toolbar", !isMobile && "sticky")}>
        <CCardBody>
          <FormToolbar mode="rating" editData={data} />
        </CCardBody>
      </CCard>

      <CCard>
        <CCardBody className="px-0 pt-4">
          <FormTable
            mode="rating"
            formId={data?.id}
            suppliers={data?.suppliers}
          />
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
export default DanhSachNhaCungCapChamDiem;
